import { render } from "./TrainingRequistion.vue?vue&type=template&id=7c4b88dd"
import script from "./TrainingRequistion.vue?vue&type=script&lang=js"
export * from "./TrainingRequistion.vue?vue&type=script&lang=js"

import "./TrainingRequistion.vue?vue&type=style&index=0&id=7c4b88dd&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__